export default __webpack_public_path__ + "static/media/wi-cloudy.ba3686e4.svg";